import { trackingEvent } from '@notino/web-tracking';

import { dispatchEcommerceMessage } from '../../../messagingService';
import { EcommerceSectionNamespace } from '../../model';

export const trackPaymentDialogBackAction = (timing: number) => {
  dispatchEcommerceMessage(
    trackingEvent({
      event: EcommerceSectionNamespace.EEcommerceEvent.ELEMENT_CLICK,
      element: {
        type: EcommerceSectionNamespace.EEcommercePageType.ORDER_AS_LAST_TIME,
        action: EcommerceSectionNamespace.EEcommerceAction.CLICK_ON_PAYMENT_DIALOG_BACK,
        interaction: EcommerceSectionNamespace.EEcommerceInteraction.CLICK,
        name: EcommerceSectionNamespace.EEcommerceName.PAYMENT_DIALOG_BACK,
        mode: undefined,
        timing,
      },
      _clear: true,
    }),
  );
};
